import React from 'react';
import FormDefault from '~/components/FormDefault';
import Search from '~/components/Search';
import { Container } from './styles';
import { useMoviProducao } from './hooks/useMoviProducao';
import DefaultLoader from '~/components/DefaultLoader';
import { Form } from './components/Form';
import { Table } from './components/Table';
import { Footer } from './components/Footer';

export const MoviProducaoContent: React.FC = () => {
  const {
    onSave,
    setShowSearch,
    showSearch,
    isUpdate,
    flgCancelado,
    loading,
    resetFormData,
    onRowClick,
    onNew,
    handleCancelProd,
    formTela: { watch },
  } = useMoviProducao();

  if (loading) {
    return (
      <Container>
        <DefaultLoader />
      </Container>
    );
  }

  return (
    <Container>
      {showSearch && (
        <Search codTela={319} newData={onNew} onRowClick={onRowClick} />
      )}
      {!showSearch && (
        <FormDefault
          title="Movimento de Produção"
          codTela={319}
          codigoRegistro={[
            {
              value: watch('cod_seq_producao'),
              des_campo: 'Código da Produção',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          onCancel={() => setShowSearch(true)}
          isSave={isUpdate}
          isUpdate={isUpdate}
          onNew={onNew}
          onDelete={handleCancelProd}
          isDeactivateDeleteMessage={flgCancelado}
          labelButtonTrash="Cancelar Produção"
          deleteMessage="Deseja realmente cancelar o registro?"
          onClearFields={resetFormData}
          onReturnSearch={() => setShowSearch(true)}
          widthDeleteButton="200px"
        >
          <Form />
          <Table />
          <Footer />
        </FormDefault>
      )}
    </Container>
  );
};
